import React, { useEffect, useState, useRef } from 'react';
import { NavHashLink } from 'react-router-hash-link';
import '../chillOut.css';
import scrolldown from '../img/Arrow Down.png';
import insider1 from '../img/Chill out/image 3.png';
import insider2 from '../img/Chill out/Photo 17-2-23, 11 06 58 AM 2.png';
import insider3 from '../img/Chill out/Photo 17-2-23, 12 19 29 PM 2.png';
import insider4 from '../img/Chill out/Screenshot 2023-02-24 at 2.38 1.png';
import insider5 from '../img/Chill out/Group 22.png';
import arrow1 from '../img/Vector 2.png';
import arrow2 from '../img/Vector 1.png';
import arrow3 from '../img/Vector 6.png';
import arrow4 from '../img/Vector 3.png';
import bannerImg from '../img/Chill out/TNZ - Space - Hells Gate - FF6A3783 2.jpeg';
import bannerImgMobile from '../img/Chill out/TNZ - Space - Hells Gate - FF6A3783 3.jpeg';
import activityBanner1 from '../img/Chill out/Hells_Gate-Rotorua-Miles Holden 1.jpg';
import activityImg1 from '../img/Chill out/lovetaupo 2.jpg';
import activityImg2 from '../img/Chill out/WINTER FESTIVAL - Queenstown 1.jpg';
import activityImg3 from '../img/Chill out/Tirama mai-models-27 1.jpg';
import activityImg4 from '../img/Chill out/marlboroughnz 1.jpg';
import foodImg1 from '../img/Chill out/header-vineyard-kitchen 1.jpg';
import foodImg2 from '../img/Chill out/iconiceats.co 1.jpg';
import foodImg3 from '../img/Chill out/Yealands 1120_RBPHOTO (1) 1.jpg';
import foodImg4 from '../img/Chill out/Te-Puia-NZ-HERO-Pataka-Kai-Restaurant-Steam-Pudding-1024x683 1.jpg';
import foodImg5 from '../img/Chill out/Dark-Sky-Diner-CMYK-Hero-1670 1 copy.jpg';
import LodgingCarousel from '../components/chillout-lodging-carousel';
import mountain from '../img/image 1.png';
import booknow from '../img/Book Now Button.png';
import arrowRight from '../img/Arrow Right - transparent.png';
import arrowLeft from '../img/Arrow Left - transparent.png';

import activityImg2Mobile from '../img/Chill out/WINTER FESTIVAL - Queenstown 2.jpg';
import foodImg1Mobile from '../img/Chill out/header-vineyard-kitchen 2.jpeg';
import foodImg2Mobile from '../img/Chill out/iconiceats.co 2.jpg';
import foodImg3Mobile from '../img/Chill out/Te-Puia-NZ-HERO-Pataka-Kai-Restaurant-Steam-Pudding-1024x683 1 copy.jpg';
import foodImg4Mobile from '../img/Chill out/Yealands 1120_RBPHOTO (1) 1.jpg';
import foodImg5Mobile from '../img/Chill out/Dark-Sky-Diner-CMYK-Hero-1670 1.jpg';
import insider1Mobile from '../img/Chill out/image 3.jpg';
import insider2Mobile from '../img/Chill out/Photo 17-2-23, 11 06 58 AM 3.jpg';
import insider3Mobile from '../img/Chill out/Photo 17-2-23, 12 19 29 PM 1.jpg';
import insider5Mobile from '../img/Chill out/Screenshot 2023-02-24 at 2.38 2.jpg';
import familyIcon from '../img/Family Friendly Icon.png';

import video from '../img/Chill out/CA_Insider_1_Skywire.mp4';
import { useLocation } from 'react-router-dom';

const ChillOut = ({ winterEscapeRef }) => {
    const [isPlaying, setIsPlaying] = useState(false);
    const togglePlay = () => {
        setIsPlaying(!isPlaying);
    };
    
    const location = useLocation()
    useEffect(() => {
        if (location.hash === "#review") {
            setTimeout(() => {
                ref4.current.scrollIntoView({ behavior: "smooth" });
            }, 500)
        }
    }, [location]);

    const ref1 = useRef(null);
    const ref2 = useRef(null);
    const ref3 = useRef(null);
    const ref4 = useRef(null);
    const ref5 = useRef(null);

    const handleClick = (ref) => (event) => {
        event.preventDefault();
        if (ref.current) {
            console.log(ref.current);
            ref.current.scrollIntoView({ behavior: "smooth" });
        }
    };

    return (
        <>
            <div id="top" className="subPage-banner" ref={ref5}>
                <div className="banner-img desktop"><img src={bannerImg} alt="banner-img" /></div>
                <div className="banner-img mobile"><img src={bannerImgMobile} alt="banner-img-mobile" /></div>
                <div className="banner-header"><h1 data-aos="zoom-out">Chill Out<br />and About</h1></div>
                <div className="btm-text">
                    <div className="name">Tikitere (Hell's Gate), Rotorua</div>
                </div>
            </div>
            <div className="subMenu pt-4 pt-sm-0">
                <ul className="d-flex align-items-center justify-content-between">
                    <li><a href="#activities" onClick={handleClick(ref1)}>Activities</a></li>
                    <li><a href="#dining" onClick={handleClick(ref2)}>Dining</a></li>
                    <li><a href="#lodging" onClick={handleClick(ref3)}>Lodging</a></li>
                    <li><a href="#review" onClick={handleClick(ref4)}>Christabel Chua's Review</a></li>
                </ul>
            </div>
            <div className="peakThrills-activities container section">
                <div className="anchor" id="activities" ref={ref1}></div>
                <div className="content" data-aos="fade-up">
                    <h2 className="violet">Activities</h2>
                    <h3 className="pt-sm-3 desktop">Soak in the relaxing winter atmosphere while enjoying cultural and culinary delights.</h3>
                    <h3 className="pt-sm-3 mobile">Soak in the relaxing winter <br />atmosphere while enjoying <br />cultural and culinary delights.</h3>
                    <p className="pt-sm-5 pt-4">Escape the heat and the bustle of summer with Air New Zealand for a relaxing winter retreat – but don't forget your togs (swimwear)! Revel in the festivities of the Māori New Year (late June to early July) and savour the fruits of the land. Check out some of our best picks for the season.</p>
                </div>
            </div>
            <div data-aos="fade-up">
                <div className="thumbnail-banner activities-thumbnail-banner mb-5 pt-5 pt-sm-0">
                    <img className="full-width" src={activityBanner1} alt="activity-banner-1" />
                </div>
                <div className="activity-body p-left">
                    <div className="content">
                        <div className="d-flex align-items-center">
                            <h3>Tikitere (Hell's Gate), <span className="violet">Rotorua</span></h3>
                            <div className="family-tooltip ms-4">
                                <img className="family-icon" src={familyIcon} alt="family-icon" />
                                <span className="tooltip-hover-text">
                                    Family-friendly
                                </span>
                            </div>
                        </div>
                        <p>Enjoy a fun family soak as you discover the natural healing properties of geothermal mud and sulphur mineral water at New Zealand's only geothermal mud bath experience.</p>
                        <p className="small-text light-italic location">351 State Highway 30 Tikitere, Rotorua <br />New Zealand</p>
                    </div>
                </div>
                <div className="activity-body section chillOut-activities">
                    <div className="row">
                        <div className="col-sm-6 left-col activity-body-col-1">
                            <div className="p-left-2x p-right activity-body-col-1-wrap">
                                <div className="thumbnail-img pt-5 w-sm-5 pe-5 pe-sm-0">
                                    <img className="full-width" src={activityImg1} alt="activity-img-1" />
                                    <div className="copyright white">© Love Taupo</div>
                                </div>
                                <div className="content pt-5 pt-sm-3 pb-5 w-sm-5 pe-5 pe-sm-0">
                                    <div className="d-flex align-items-center">
                                        <h3>Taupo DeBretts Spa Resort, <span className="violet">Taupo</span></h3>
                                        <div className="family-tooltip ms-4">
                                            <img className="family-icon" src={familyIcon} alt="family-icon" />
                                            <span className="tooltip-hover-text">
                                                Family-friendly
                                            </span>
                                        </div>
                                    </div>
                                    <p>Explore this award-winning thermal resort with lodging, spa, and a massive kids warm-water interactive playground for guaranteed fun for the entire family.</p>
                                    <p className="small-text light-italic location desktop">76 Napier-Taupo Road, SH 5, Taupo, <br />New Zealand</p>
                                    <p className="small-text light-italic location mobile">76 Napier-Taupo Road, SH 5, <br />Taupo, New Zealand</p>
                                </div>
                            </div>
                            <div className="pe-5 pe-sm-0">
                                <div className="desktop">
                                    <div className="thumbnail-img pt-5">
                                        <img className="full-width" src={activityImg2} alt="activity-img-1" />
                                    </div>
                                    <div className="pt-5 p-left-2x activity-body-col-2-wrap">
                                        <div className="content pt-3 pb-5 px-5 px-sm-0">
                                            <div className="d-flex align-items-center">
                                                <h3 className="grid">Queenstown Winter Festival, <span className="violet">Queenstown</span></h3>
                                                <div className="family-tooltip ms-4">
                                                    <img className="family-icon" src={familyIcon} alt="family-icon" />
                                                    <span className="tooltip-hover-text">
                                                        Family-friendly
                                                    </span>
                                                </div>
                                            </div>
                                            <p>Welcome winter with live music, spectacular fireworks, quirky competitions (dog barking, anyone?), comedy nights and more. Endless fun for everyone at this annual festival from late June to early July.</p>
                                        </div>
                                        <div className="content mt-5 pt-5">
                                            <div className="tip-box seat mt-5" data-aos="zoom-out">
                                                <p>
                                                    <span className="weight-medium">Air New Zealand Travel Tip:</span><br />
                                                    Get the best economy seat by upgrading to Economy Skycouch™. Enjoy unparalleled spaciousness to spread out and lie down for a snooze – it's like a sofa bed in the skies!
                                                </p>
                                                <button><a href="https://www.airnewzealand.com.sg/economy-skycouch" target="_blank">Learn More</a></button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-6 right-col p-left-half activity-body-col-2">
                            <div className="p-right-2x pb-5 activity-body-col-2-wrap">
                                <div className="thumbnail-img pt-5">
                                    <img className="full-width" src={activityImg3} alt="activity-img-2" />
                                </div>
                                <div className="content pt-3 px-5 px-sm-0">
                                    <div className="d-flex align-items-center">
                                        <h3>Matariki Festival, <span className="violet">Auckland</span></h3>
                                        <div className="family-tooltip ms-4">
                                            <img className="family-icon" src={familyIcon} alt="family-icon" />
                                            <span className="tooltip-hover-text">
                                                Family-friendly
                                            </span>
                                        </div>
                                    </div>
                                    <p>Treat your children to a spectacle in the skies. Stargaze for the Matariki cluster that marks the Māori New Year (late June to early July), as you experience the rich history and deep admiration for the world around us.</p>
                                </div>
                            </div>
                            <div className="p-left pt-5 mt-5 activity-body-col-1-wrap">
                                <div className="thumbnail-img w-sm-5 pt-0 pt-sm-5 mt-0 mt-sm- pe-5 pe-sm-0">
                                    <img className="full-width" src={activityImg4} alt="activity-img-2" />
                                    <div className="copyright white">© Marlborough NZ</div>
                                </div>
                                <div className="content w-sm-5 pt-3 pe-5 pe-sm-0">
                                    <h3>Winter Fireplace Trail, <span className="violet">Marlborough</span></h3>
                                    <p>Savour the best of New Zealand wine while taking in the warmth of the fireplace, overlooking sweeping views of wintry vineyards.</p>
                                </div>
                            </div>
                            <div className="mobile pt-3">
                                <div className="thumbnail-img pt-5">
                                    <img className="full-width" src={activityImg2Mobile} alt="activity-img-1" />
                                </div>
                                <div className="pt-5 p-left-2x activity-body-col-2-wrap">
                                    <div className="content px-5">
                                        <div className="d-flex align-items-center">
                                            <h3 className="grid">Queenstown Winter Festival, <span className="violet">Queenstown</span></h3>
                                            <div className="family-tooltip ms-4">
                                                <img className="family-icon" src={familyIcon} alt="family-icon" />
                                                <span className="tooltip-hover-text">
                                                    Family-friendly
                                                </span>
                                            </div>
                                        </div>
                                        <p>Welcome winter with live music, spectacular fireworks, quirky competitions (dog barking, anyone?), comedy nights and more. Endless fun for everyone at this annual festival from late June to early July.</p>
                                    </div>
                                    <div className="content pt-3 px-5" data-aos="zoom-out">
                                        <div className="tip-box seat mt-5">
                                            <p>
                                                <span className="weight-medium">Air New Zealand Travel Tip:</span><br />
                                                Get the best economy seat by upgrading to Economy Skycouch™. Enjoy unparalleled spaciousness to spread out and lie down for a snooze – it's like a sofa bed in the skies!
                                            </p>
                                            <button><a href="https://www.airnewzealand.com.sg/economy-skycouch" target="_blank">Learn More</a></button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="scroll-down text-center pt-5 mt-0 mt-sm-5 z-index-1" data-aos="zoom-out">
                <p className="violet"><span className="serif-bold">Next up,</span> Dining</p>
                <a href="#food" onClick={handleClick(ref2)} className="scroll-down-btn"><img src={scrolldown} alt="scroll-down" /></a>
            </div>
            <div className="section food purple-bg position-relative">
                <div className="anchor" id="dining" ref={ref2}></div>
                <div className="food-header text-center pb-5 px-5 px-sm-0" data-aos="fade-up">
                    <h2 className="violet">Dining</h2>
                    <h3 className="pt-4">Get a taste of culture and comfort to pair with some delicious drinks.</h3>
                    <p className="pt-4 pt-sm-5">Unlock the full experience of New Zealand with Māori cooking, and unwind (with wine) while enjoying nourishing meals to heal your mind, body and soul.</p>
                </div>
                <div className="food-body desktop position-relative" data-aos="fade-up">
                    <div className="row pt-5 pb-5">
                        <div className="col-sm-7 left-col pe-5">
                            <div className="thumbnail-img">
                                <img className="full-width" src={foodImg1} alt="food-img-1" />
                                <div className="copyright white">© Saint Clair Family Estate</div>
                            </div>
                            <div className="content pt-3 pb-5">
                                <h3>St Clair Vineyard Kitchen, <span className="violet">Marlborough</span></h3>
                                <p>Dinner by the fireplace for a toasty & tasty meal</p>
                                <p className="small-text light-italic location">13 Selmes Road, Blenheim 7273, Marlborough, <br />New Zealand</p>
                            </div>
                            <div className="thumbnail-img">
                                <img className="full-width" src={foodImg2} alt="food-img-3" />
                                <div className="copyright white">© Babiche Martens</div>
                            </div>
                            <div className="content pt-3 pb-5">
                                <h3>Blue Rose Café, <span className="violet">Auckland </span></h3>
                                <p>Rich Māori flavours packed within this hāngī pie</p>
                                <p className="small-text light-italic location">414 Sandringham Road,<br />Sandringham, Auckland 1025, New Zealand</p>
                            </div>
                        </div>
                        <div className="col-sm-5 right-col ps-5">
                            <div className="thumbnail-img">
                                <img className="full-width" src={foodImg3} alt="food-img-2" />
                                <div className="copyright white">© Yealands Estate</div>
                            </div>
                            <div className="content pt-3 pb-5">
                                <h3>Yealands Estate, <span className="violet">Marlborough </span></h3>
                                <p>Sustainable wine tasting to pair with delicious platters</p>
                                <p className="small-text light-italic location">Cnr Seaview and Reserve Roads New Zealand <br />Seddon, Blenheim 7285, New Zealand</p>
                            </div>
                            <div className="thumbnail-img">
                                <img className="full-width" src={foodImg4} alt="food-img-4" />
                                <div className="copyright">© Pātaka Kai Restaurant</div>
                            </div>
                            <div className="content pt-3">
                                <h3>Pātaka Kai Restaurant, <span className="violet">Rotorua </span></h3>
                                <p>Savour Māori cuisine including puddings steamed with natural geothermal heatl</p>
                                <p className="small-text light-italic location">20 Hemo Road, Whakarewarewa, Rotorua 3010, <br />New Zealand</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="full-width desktop pb-5 mb-3">
                    <div className="thumbnail-img">
                        <img className="full-width" src={foodImg5} alt="food-img-3" />
                        <div className="copyright white">© Dark Sky Project</div>
                    </div>
                    <div className="content pt-3 food-body">
                        <h3>Dark Sky Diner, <span className="violet">Lake Tekapo</span></h3>
                        <p>Stunning views of the lake to complement an international cuisine</p>
                        <p className="small-text light-italic location">1 Motuariki Lane, Lake Tekapo 7999, <br />New Zealand</p>
                    </div>
                </div>
                <div className="food-body mobile" data-aos="fade-up">
                    <div className="row row-2 py-5">
                        <div className="col-12 px-0">
                            <div className="thumbnail-img">
                                <img className="full-width" src={foodImg1Mobile} alt="food-img-2" />
                                <div className="copyright white">© Saint Clair Family Estate</div>
                            </div>
                        </div>
                        <div className="col-12 px-5">
                            <div className="content">
                                <h3>St Clair Vineyard Kitchen, <span className="violet">Marlborough</span></h3>
                                <p>Dinner by the fireplace for a toasty & tasty meal</p>
                                <p className="small-text light-italic location">13 Selmes Road, Blenheim 7273, Marlborough, <br />New Zealand</p>
                            </div>
                        </div>
                    </div>
                    <div className="row row-1 pb-5 d-flex align-items-center">
                        <div className="col-6 ps-5">
                            <div className="content">
                                <h3>Yealands Estate, <span className="violet">Marlborough </span></h3>
                                <p>Sustainable wine tasting to pair with delicious platters</p>
                                <p className="small-text light-italic location">Cnr Seaview and Reserve Roads New Zealand Seddon, Blenheim 7285, New Zealand</p>
                            </div>
                        </div>
                        <div className="col-6 ps-5 pe-0">
                            <div className="thumbnail-img">
                                <img className="full-width" src={foodImg4Mobile} alt="food-img-1" />
                                <div className="copyright white">© Yealands Estate</div>
                            </div>
                        </div>
                    </div>
                    <div className="row row-2 py-5">
                        <div className="col-12 px-0">
                            <div className="thumbnail-img">
                                <img className="full-width" src={foodImg2Mobile} alt="food-img-2" />
                                <div className="copyright white">© Babiche Martens</div>
                            </div>
                        </div>
                        <div className="col-12 px-5">
                            <div className="content">
                                <h3>Blue Rose Café, <span className="violet">Auckland </span></h3>
                                <p>Rich Māori flavours packed within this hāngī pie</p>
                                <p className="small-text light-italic location">414 Sandringham Road,<br />Sandringham, Auckland 1025, New Zealand</p>
                            </div>
                        </div>
                    </div>
                    <div className="row row-3 d-flex align-items-center pb-5">
                        <div className="col-6 pe-5 ps-0">
                            <div className="thumbnail-img">
                                <img className="full-width" src={foodImg3Mobile} alt="food-img-3" />
                                <div className="copyright">© Pātaka Kai Restaurant</div>
                            </div>
                        </div>
                        <div className="col-6 pe-5">
                            <div className="content">
                                <h3>Pātaka Kai Restaurant, <span className="violet">Rotorua </span></h3>
                                <p>Savour Māori cuisine including puddings steamed with natural geothermal heatl</p>
                                <p className="small-text light-italic location">20 Hemo Road, Whakarewarewa, Rotorua 3010, New Zealand</p>
                            </div>
                        </div>
                    </div>
                    <div className="row row-4 py-5">
                        <div className="col-12 px-0">
                            <div className="thumbnail-img">
                                <img className="full-width" src={foodImg5Mobile} alt="food-img-4" />
                                <div className="copyright">© Dark Sky Project</div>
                            </div>
                        </div>
                        <div className="col-12 px-5">
                            <div className="content">
                                <h3>Dark Sky Diner, <span className="violet">Lake Tekapo</span></h3>
                                <p>Stunning views of the lake to complement <br />an international cuisine</p>
                                <p className="small-text light-italic location">1 Motuariki Lane, Lake Tekapo 7999, New Zealand</p>
                            </div>
                        </div>
                    </div>
                    <div className="scroll-down absolute text-center pt-4 full-width mobile" data-aos="zoom-out">
                        <p className="violet"><span className="serif-bold">Next up,</span> Lodging</p>
                        <a href="#review" onClick={handleClick(ref4)} class="scroll-down-btn"><img src={scrolldown} alt="scroll-down" /></a>
                    </div>
                </div>
                <div className="scroll-down absolute text-center pt-4 full-width desktop" data-aos="zoom-out">
                    <p className="violet"><span className="serif-bold">Next up,</span> Lodging</p>
                    <a href="#review" onClick={handleClick(ref4)} class="scroll-down-btn"><img src={scrolldown} alt="scroll-down" /></a>
                </div>
            </div>

            <div className="section lodging" data-aos="fade-up">
                <div className="anchor" id="lodging" ref={ref3}></div>
                <div className="row">
                    <div className="col-sm-4 col-12 p-left pt-5 pe-5 pe-sm-0 ps-5">
                        <h2 className="violet">Lodging</h2>
                        <div className="header lodging chillout">
                            <h3 className="pt-3 desktop">Your ideal rest-capade is <br />waiting for you.</h3>
                            <h3 className="pt-3 mobile">Your ideal rest-capade <br />is waiting for you.</h3>
                            <p className="pt-3">Explore a range of accommodations that focus on rest and rejuvenation. Heal your mind, body and soul with everything you need in one place.</p>
                        </div>
                    </div>
                    <div className="col-sm-8 col-sm-12 p-left">
                        <LodgingCarousel />
                    </div>
                </div>
            </div>
            <div className="scroll-down text-center pt-0 pt-sm-5 mt-0 mt-sm-5" data-aos="zoom-out">
                <p className="violet"><span className="serif-bold">Next up,</span> Insider's Trip Review</p>
                <a href="#review" onClick={handleClick(ref4)} class="scroll-down-btn"><img src={scrolldown} alt="scroll-down" /></a>
            </div>

            <div id="review" ref={ref4}>
                <div className="section purple-bg subPage-reviews desktop">
                    {/* <div className="anchor" id="review" ref={ref4}></div> */}
                    <div data-aos="fade-up">
                        <h2 className="text-center violet py-5">Insider's Trip Review:</h2>
                        <div className="row pt-5">
                            <div className="col-sm-6 p-right-half">
                                <div className="content m-right-0">
                                    <h3>Christabel Chua (@bellywellyjelly)</h3>
                                    <p>Check out how Christabel took “chill” to greater heights (literally) while reconnecting with nature, culture and her inner self. Gather inspiration for your own travel therapy with a relaxing trip to New Zealand this winter.</p>
                                </div>
                            </div>
                            <div className="col-sm-6 p-left-half">
                                <div className="tip-box insider">
                                    <p>
                                        <span className="weight-medium">Christabel's Trip Tip:</span><br />
                                        Wear covered shoes and keep warm, especially when it gets windy on some activities! You want to stay warm and toasty.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="row section px-sm-4">
                            <div className="col-sm-7 ps-sm-0 left-col pe-5 mt-5 p-left insider-overlap-top-section-wrap chillout">
                                <div className="d-flex flex-wrap pe-5 insider-overlap-top-section align-items-end">
                                    <div className="w-5 insider-top-section-content chillout pb-5 mb-5">
                                        <div className="content absolute">
                                            <h4 data-aos="fade-in" data-aos-delay="500">“It was super chill with views of Nelson Bay that are hard to beat.”</h4>
                                        </div>
                                        <div className="thumbnail-img pt-5 text-right">
                                            <img className="w-6" src={insider4} alt="activity-img=3" />
                                            <img className="thumbnail-arrow desktop" data-aos="fade-in" src={arrow3} alt="arrow-1" />
                                        </div>
                                    </div>
                                    <div className="w-5">
                                        <div className="thumbnail-img video">
                                            <img className="full-width" src={insider5} alt="activity-img=3" onClick={togglePlay} />
                                            {isPlaying && (
                                                <video control controls={true} autoPlay={true} muted={true}>
                                                    <source src={video} type="video/mp4" />
                                                </video>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-sm-5 right-col">
                                <div className="content insider-overlap-top-section-content chillout">
                                    <h3 className="number violet">1</h3>
                                    <h3>The Skywire Experience at Cable Bay Adventure Park, <span className="violet">Nelson</span></h3>
                                    <p className="pt-3">As the world's longest flying fox at 3.2km return with speeds up to 100km/h, it's so relaxing that you'd wish you could go on for another ride.</p>
                                    <p className="pt-3">It sounds scary and I was petrified too, but this activity is for even the most faint-hearted. An experience that would make you feel small in this beautiful world we live in.</p>
                                </div>
                            </div>
                        </div>
                        <div className="insider-overlap-section chillout">
                            <div className="z-index-3 overlapping-row d-flex flex-wrap">
                                <div className="w-4"></div>
                                <div className="w-6">
                                    <div className="top d-flex">
                                        <div className="images w-6">
                                            <img className="thumbnail-img" src={insider1} alt="insider-1" />
                                            <img className="thumbnail-arrow desktop" data-aos="fade-in" src={arrow1} alt="arrow-1" />
                                            <img className="thumbnail-arrow mobile" src={arrow4} alt="arrow-4" />
                                            <div className="content mobile">
                                                <h3 className="number violet">2</h3>
                                                <h3>Seal Spotting, <span className="violet">Kaikōura</span> </h3>
                                                <p className="pt-3">I highly recommend coming with a warm cuppa and a snack in hand. Having these magnificent creatures bask in the sun beside you was quite surreal. It was really therapeutic.</p>
                                            </div>
                                        </div>
                                        <div className="content w-4 pb-5 ps-5">
                                            <h4 data-aos="fade-in">“Allow yourself to slow down a little and enjoy the company of seals.”</h4>
                                        </div>
                                    </div>
                                    <div className="bottom">
                                        <div className="content">
                                            <h3 className="number violet">2</h3>
                                            <h3>Seal Spotting, <span className="violet">Kaikōura</span> </h3>
                                            <p className="pt-3">I highly recommend coming with a warm cuppa and a snack in hand. Having these magnificent creatures bask in the sun beside you was quite surreal. It was really therapeutic.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="z-index-1 overlapping-row">
                                <div className="top d-flex align-items-end">
                                    <div className="content w-4 pe-5">
                                        <h4 data-aos="fade-in">“One of the best things you can do for your mental health.”</h4>
                                    </div>
                                    <div className="images w-6">
                                        <div className="thumbnail-img-container">
                                            <img className="thumbnail-img" alt="insider-2" src={insider2} />
                                        </div>
                                        <img className="thumbnail-arrow desktop" data-aos="fade-in" src={arrow2} alt="arrow-2" />
                                        <img className="thumbnail-arrow mobile" src={arrow4} alt="arrow-4" />
                                    </div>
                                </div>
                                <div className="bottom">
                                    <div className="content w-4">
                                        <h3 className="number violet">3</h3>
                                        <h3>Waka Abel Tasman, <span className="violet">Nelson</span> </h3>
                                        <p className="pt-3">Paddle your way across waters while learning about the Māori culture and heritage in the most immersive way. An experience you'll never get anywhere else.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="z-index-2 overlapping-row d-flex">
                                <div className="w-45"></div>
                                <div className="w-55">
                                    <div className="top d-flex align-items-end">
                                        <div className="images col-sm-12">
                                            <img className="thumbnail-img" src={insider3} alt="insider-3" />
                                            <img className="thumbnail-arrow desktop" data-aos="fade-in" src={arrow3} alt="arrow-3" />
                                            <img className="thumbnail-arrow mobile" src={arrow1} alt="arrow-1" />
                                        </div>
                                    </div>
                                    <div className="bottom d-flex align-items-center">
                                        <div className="content w-5">
                                            <h3 className="number violet">4</h3>
                                            <h3>Fish & Chips, <span className="violet">Kaikōura</span> </h3>
                                            <p className="pt-3">Each bite is filled with the freshest flaky fish chunks coated just the right amount of batter. I had it 2-3 times each day while I was there!</p>
                                        </div>
                                        <div className="content w-5 ps-5 right">
                                            <h4 data-aos="fade-in">“Go for the fried cod. No words can fully describe how wonderful it tastes.”</h4>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="section purple-bg subPage-reviews mobile">
                    {/* <div className="anchor" id="review" ref={ref4}></div> */}
                    <div data-aos="fade-up">
                        <h2 className="text-center violet pt-5">Insider's Trip Review:</h2>
                        <div className="row pt-0 px-5 text-center">
                            <div className="col-sm-6">
                                <div className="content m-right-0">
                                    <h3>Christabel Chua (@bellywellyjelly)</h3>
                                    <p>Check out how Christabel took “chill” to greater heights (literally) while reconnecting with nature, culture and her inner self. Gather inspiration for your own travel therapy with a relaxing trip to New Zealand this winter.</p>
                                </div>
                            </div>
                            <div className="col-sm-6 pt-5">
                                <div className="tip-box insider">
                                    <p>
                                        <span className="weight-medium">Christabel's Trip Tip: </span><br />
                                        Wear covered shoes and keep warm, especially when it gets windy on some activities! You want to stay warm and toasty.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="row pt-5 align-items-end">
                            <div className="col-6 pe-2 insider-top-section-img-mobile left-col mt-5">
                                <div className="thumbnail-img video">
                                    <img className="full-width" src={insider5} alt="activity-img=3" onClick={togglePlay} />
                                    {isPlaying && (
                                        <video control controls={true} autoPlay={true} muted={true}>
                                            <source src={video} type="video/mp4" />
                                        </video>
                                    )}
                                </div>
                            </div>
                            <div className="col-6 ps-2 insider-top-section-img-mobile right-col chillout">
                                <div className="thumbnail-img pt-5">
                                    <img className="full-width" src={insider5Mobile} alt="activity-img=3" />
                                    <img className="thumbnail-arrow" src={arrow3} alt="arrow-4" />
                                </div>
                            </div>
                        </div>
                        <div className="col-12 px-5 insider-top-section-content-mobile chillout pb-5">
                            <div className="content pt-3 w-sm-5">
                                <h4>“It was super <br />chill with views of Nelson Bay that <br />are hard to beat.”</h4>
                            </div>
                            <div className="content pt-3">
                                <h3 className="number violet">1</h3>
                                <h3>The Skywire Experience at Cable <br />Bay Adventure Park, <span className="violet">Nelson</span></h3>
                                <p className="pt-3">As the world's longest flying fox at 3.2km return with speeds up to 100km/h, it's so relaxing that you'd wish you could go on for another ride.</p>
                                <p className="pt-3">It sounds scary and I was petrified too, but this activity is for even the most faint-hearted. An experience that would make you feel small in this beautiful world we live in.</p>
                            </div>
                        </div>
                        <div className="insider-sub-section chillout">
                            <div className="row row-1">
                                <div className="col-12 px-0 relative">
                                    <img className="thumbnail-img full-width" src={insider1Mobile} alt="insider-1" />
                                    <img className="thumbnail-arrow" src={arrow3} alt="arrow-4" />
                                </div>
                            </div>
                            <div className="row align-items-center row-1-content">
                                <div className="col-7 ps-5 pe-2">
                                    <div className="content">
                                        <h3 className="number violet">2</h3>
                                        <h3>Seal Spotting, <span className="violet">Kaikōura</span> </h3>
                                        <p className="">I highly recommend coming with a warm cuppa and a snack in hand. Having these magnificent creatures bask in the sun beside you was quite surreal. It was really therapeutic.</p>
                                    </div>
                                </div>
                                <div className="col-5 ps-2 pe-5">
                                    <div className="content right">
                                        <h4>“Allow yourself to slow down a little and enjoy the company of seals.”</h4>
                                    </div>
                                </div>
                            </div>
                            <div className="row row-2 pt-5 align-items-end pb-5 ">
                                <div className="col-6 ps-5 pe-2">
                                    <div className="content top">
                                        <h4>“One of the <br />best things you can do for your mental health.”</h4>
                                    </div>
                                    <div className="content w-4">
                                        <h3 className="number violet">3</h3>
                                        <h3>Waka Abel Tasman, <span className="violet">Nelson</span> </h3>
                                        <p className="">Paddle your way across waters while learning about the Māori culture and heritage in the most immersive way. An experience you'll never get anywhere else.</p>
                                    </div>
                                </div>
                                <div className="col-6 ps-2 pe-0 relative">
                                    <img className="thumbnail-img full-width" src={insider2Mobile} alt="insider-1" />
                                    <img className="thumbnail-arrow" src={arrow4} alt="arrow-4" />
                                </div>
                            </div>
                            <div className="row row-3 align-items-center pt-5">
                                <div className="col-12 px-0 relative">
                                    <img className="thumbnail-img full-width" src={insider3Mobile} alt="insider-1" />
                                    <img className="thumbnail-arrow" src={arrow3} alt="arrow-4" />
                                </div>
                                <div className="col-6 ps-5 pe-5">
                                    <div className="content left">
                                        <h4>“Go for the <br />fried cod. <br />No words can <br />fully describe <br />how wonderful <br />it tastes.”</h4>
                                    </div>
                                </div>
                                <div className="col-6 ps-3 pe-5">
                                    <div className="content w-4">
                                        <h3 className="number violet">4</h3>
                                        <h3>Fish & Chips, <span className="violet">Kaikōura</span> </h3>
                                        <p className="">Each bite is filled with the freshest flaky fish chunks coated just the right amount of batter. I had it 2-3 times each day while I was there!</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="purple-bg mountainImg">
                <img className="full-width" src={mountain} alt="mountain" />
            </div>
            <div className="footer-CTA text-center px-5" data-aos="fade-up">
                <h2 className="pb-4">Ready for your winter escape?</h2>
                <a ref={winterEscapeRef} href="https://flightbookings.airnewzealand.com.sg/vbook/actions/ext-search" target="_blank"><img className="bookNow-btn" src={booknow} alt="booknow" /></a>
            </div>
            <div className="newsletter purple-bg section text-center">
                <p className="violet weight-medium">Get the latest flight deals and travel tips</p>
                <h2 className="pb-4">Join our newsletter</h2>
                <button><a href="https://www.airnewzealand.com.sg/email-offer-signup" target="_blank">Sign Up</a></button>
            </div>
            <div className="services-page purple-bg">
                <div className="row d-flex flex-wrap">
                    <div className="col-6 services-pagination-col peak d-flex flex-wrap align-items-center justify-content-start">
                        <NavHashLink to='/peak-thrills'><img className="prevArrow me-3" src={arrowLeft} alt="arrow-left" /></NavHashLink>
                        <NavHashLink to='/peak-thrills'><h2>Peak Thrills</h2></NavHashLink>
                    </div>
                    <div className="col-6 text-right services-pagination-col wonders d-flex flex-wrap align-items-center justify-content-end">
                        <NavHashLink to='/wonders-in-the-wild'><h2>Wonders in the Wild</h2></NavHashLink>
                        <NavHashLink to='/wonders-in-the-wild'><img className="nextArrow ms-3" src={arrowRight} alt="arrow-right" /></NavHashLink>
                    </div>
                    <div className="scroll-down text-center absolute">
                        <p>Back to the top</p>
                        <a href="#top"><img src={scrolldown} alt="scroll-down" /></a>
                    </div>
                </div>
            </div>
        </>
    );
};
export default ChillOut;
